<script setup>
import { computed, onMounted, reactive, ref } from 'vue';
import LanguagePicker from './LanguagePicker.vue';
import { releaseAssetUrl } from '../services/runtimeAssets.js';

const props = defineProps({
  language: String,
  languages: Array,
  flagUrl: Function,
  t: Function,
  busy: Boolean,
  error: String,
  dataMode: String,
  audio: Object
});
const emit = defineEmits(['login', 'language', 'verification-host']);
const form = reactive({ username: '', password: '' });
const verificationHost = ref(null);
const desktopLogoUrl = releaseAssetUrl('/assets/brand/wanli-script-gold-v1.webp');
const openAgentPortal = () => {
  props.audio?.play('click', { queue: false });
  window.open('https://vip.2132027.com/', '_blank', 'noopener,noreferrer');
};
const selectLanguage = (language) => {
  props.audio?.play('click', { queue: false });
  emit('language', language);
};
const loginCopy = computed(() => [
  props.t('vueDesktop.login.memberAccess', 'Member Access'),
  props.t('vueDesktop.login.memberLogin', 'Member Login'),
  props.t('vueDesktop.login.welcomeBack', 'Welcome back. Sign in to your private account.')
]);
onMounted(() => emit('verification-host', verificationHost.value));
const submit = () => emit('login', { ...form });
</script>

<template>
  <div class="login-view">
    <header class="topbar">
      <button class="agent" type="button" @click="openAgentPortal">{{ t('vueDesktop.login.agentAccess', 'Agent Access') }}</button>
      <LanguagePicker :languages="languages" :active="language" :flag-url="flagUrl" :t="t" @select="selectLanguage" />
    </header>
    <section class="content">
      <div class="brand" aria-hidden="true"><img class="mobile-brand-logo" :src="desktopLogoUrl" alt="" /><span class="brand-comet" /></div>
      <div class="card-shell">
        <form class="card" @submit.prevent="submit">
          <img class="desktop-login-logo" :src="desktopLogoUrl" alt="Wanli" />
          <div class="kicker">{{ loginCopy[0] }}</div>
          <h1 class="title">{{ loginCopy[1] }}</h1>
          <div class="copy">{{ loginCopy[2] }}</div>
          <label class="field">
            <span class="field-label">{{ t('label.username', '账号') }} / USERNAME</span>
            <span class="field-box"><span class="icon">◇</span><input v-model="form.username" autocomplete="username" /></span>
          </label>
          <label class="field">
            <span class="field-label">{{ t('label.password', '密码') }} / PASSWORD</span>
            <span class="field-box"><span class="icon">◆</span><input v-model="form.password" type="password" autocomplete="current-password" /></span>
          </label>
          <div v-if="dataMode === 'demo'" class="verify"><span class="check" aria-hidden="true"><span>✦</span></span><span>DEMO DATA · UI INTEGRATION</span></div>
          <div v-else ref="verificationHost" class="vue-turnstile-host" :aria-label="t('status.loadingVerification', 'Loading verification')" />
          <div v-if="error" class="vue-login-message" role="alert">{{ error }}</div>
          <button class="login" type="submit" :disabled="busy">{{ busy ? t('status.verifyingLogin', '正在验证登录...') : t('button.login', '登录') }}</button>
        </form>
      </div>
    </section>
    <div class="footer">WANLI · SECURE ENTERTAINMENT PLATFORM · © 2026</div>
  </div>
</template>
